import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { List } from '../../lists';
import CheckBox from './view';
import Separator from '../../separator';

export default class CheckBoxGroup extends PureComponent {
  static defaultProps = {
    selected: [],
    separator: false,
    valueKey: 'value',
  };

  static propTypes = {
    options: PropTypes.arrayOf(
      PropTypes.oneOfType({
        id: PropTypes.string.isRequired,
      }),
    ).isRequired,
    separator: PropTypes.bool,
    selected: PropTypes.array, // eslint-disable-line react/forbid-prop-types
    valueKey: PropTypes.string,
    onChange: PropTypes.func.isRequired,
  };

  onChange = (id, value) => {
    const { onChange, selected } = this.props;
    const index = selected.map(i => i.id).indexOf(id);

    if (index !== -1) {
      onChange([
        ...selected.slice(0, index),
        ...selected.slice(index + 1, selected.length),
      ]);
    } else {
      onChange([...selected, { id, value }]);
    }
  };

  renderCheckbox = ({ item }) => {
    const { valueKey, selected } = this.props;
    const { id } = item;

    return (
      <CheckBox
        key={id}
        id={id}
        value={item[valueKey]}
        option={item}
        checked={selected.map(i => i.id).indexOf(id) !== -1}
        onChange={this.onChange}
      />
    );
  };

  render() {
    const { separator, options, selected } = this.props;

    return (
      <List
        keyExtractor={item => item.id}
        data={options}
        extraData={selected}
        renderItem={this.renderCheckbox}
        ItemSeparatorComponent={
          separator ? () => <Separator height={8} transparent /> : null
        }
      />
    );
  }
}
